import moment from 'moment';
import { Strings } from './Strings';
import { AppConfig } from '../../AppConfig';

export class Helper {
  static inArray(arr, value) {
    if (!arr) return false
    return arr.indexOf(value) >= 0 ? true : false
  }

  static encodeQueryString = (data) => {
    const ret = [];
    for (const d in data) {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    }
    return ret.join('&');
  }

  static getString(key) {
    return Strings.getString(key) || key
  }

  static getErrorMsg(error) {
    let message;
    if (typeof error === 'string') {
      message = error;
    }
    if (!message) {
      if (error) {
        if (error.original && error.original.bodyJson) {
          const body = error.original.bodyJson;
          if (body && body.code && body.message) {
            message = body.message;
          }
        }
        if (!message) {
          message = error.message;
        }
        if (!message) {
          message = error.description;
        }
      }
    }
    return message || 'An error occurred. Contact customer care team if the problem persists';
  }

  static validateAndFormatEmail(email) {
    const result = email.replace(/\s/g, '')
    if (!/\S+@\S+\.\S+/.test(result)) {
      throw new Error('Invalid email');
    }
    return result.toLowerCase()
  }

  static validateAndFormatEmailV2(email) {
    const result = email.replace(/\s/g, '')
    if (!/\S+@\S+\.\S+/.test(result)) {
      return false
    }
    return result.toLowerCase()
  }

  static validateEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  static removeNullValues(body) {
    for (const key in body) {
      if (body[key] === undefined || body[key] === null) {
        delete body[key]
      }
      if (body[key] === '') {
        delete body[key]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/helpers/Helper.js